import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { REACT_APP_MODE } from "../config";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

export default props => {
  const mode = props.mode;

  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }

  if (mode === "small") {
    return (
      <Translation>
        {t => (
          <table className="table-list-simple">
            <thead>
              <tr>
                <th>{t("common.time")}</th>
                <th>{t("common.type")}</th>
                <th className="last">{t("common.value")}</th>
              </tr>
            </thead>
            <tbody>
              {props.data.map(item => {
                return (
                  <tr key={item.key}>
                    <td>
                      <Link to={`/events/${item.key}`}>
                        {DateHelper.toLocalString(item.created)}
                      </Link>
                    </td>
                    <td>
                      <Link to={`/events/${item.key}`}>{item.type}</Link>
                    </td>
                    <td className="last">
                      <Link to={`/events/${item.key}`}>
                        {item.type.toUpperCase() === "LOCATION"
                          ? `lon:${item.value.longitude},lat:${item.value.latitude}`
                          : `${item.value} ${
                              item.type.toUpperCase() === "TEMPERATURE"
                                ? "°C"
                                : ""
                            }`}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <table className="table-list-simple">
          <thead>
            <tr>
              <th>{t("common.time")}</th>
              <th>{t("common.type")}</th>
              <th>{t("common.value")}</th>
              <th className="last">{t("common.site")}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map(item => {
              return (
                <tr key={item.key}>
                  <td>
                    <Link to={`/events/${item.key}`}>
                      {DateHelper.toLocalString(item.created)}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/events/${item.key}`}>{item.type}</Link>
                  </td>
                  <td>
                    <Link to={`/events/${item.key}`}>
                      {item.type.toUpperCase() === "LOCATION"
                        ? `lon:${item.value.longitude},lat:${item.value.latitude}`
                        : `${item.value} ${
                            item.type.toUpperCase() === "TEMPERATURE"
                              ? "°C"
                              : ""
                          }`}
                    </Link>
                  </td>
                  <td className="last">
                    <Link to={`/sites/${item.site}`}>{item.site_name}</Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Translation>
  );
};
